// THIS FILE IS GENERATED, DO NOT MODIFY MANUALLY. ##checksum##: 590794670
import { createAction } from 'typesafe-actions';

import type { GoalByType } from 'state/goals/reducer';

export const setCreatedByType = createAction('GOALS/SET_CREATED_BY_TYPE')<GoalByType>();
